import { history } from '../../../../utilities/history';
import {
  postRequest,
  // patchRequest,
  handleThrowSubmissionError
} from '../../../../utilities/requests';

export const handleNext = (values, dispatch, props) => {
  history.push(props.nextRoute);
};

export const handleSubmit = async (values, dispatch, props) => {
  try {
    if (values.diff_mailing_address === 'no') {
      delete values.mailing_address_attributes;
    }
    const response = await handleRequest(values, dispatch, props);
    await uploadFiles(values, response.data.merchant_application.id);
  } catch (error) {
    handleThrowSubmissionError(error.response);
  }
};

export const handleRequest = async values => {
  const url = '/merchant_applications';
  const payload = { ...values };
  const response = await postRequest(url, payload);
  return response;
};

const uploadFiles = async (values, id) => {
  let newData = false;
  const url = `/merchant_applications/${id}/upload_documents`;
  const payload = new FormData();
  if (values.certificate && values.certificate !== true) {
    payload.append('certificate', values.certificate);
    newData = true;
  }
  if (values.article && values.article !== true) {
    payload.append('article', values.article);
    newData = true;
  }
  if (newData) {
    await postRequest(url, payload);
  }
};
